import * as React from 'react';
import { TestRun } from '../../types';
import { antGrey } from '../styles/globalStyles';

import Progress from 'antd/lib/progress';
import Space from 'antd/lib/space';
import Text from 'antd/lib/typography/Text';

const RegressionTestingCharts = (props: TestRun): JSX.Element => {
    const { completionFraction, statuses } = props;
    return (
        <div style={{ marginTop: 12, marginBottom: 12 }}>
            <Space size="large">
                <Progress
                    percent={parseFloat((completionFraction * 100).toFixed(0))}
                    type="circle"
                    strokeColor={antGrey.grey6}
                    format={(percent) => {
                        return (
                            <Space direction="vertical" align="center" size={0}>
                                <Text style={{ fontSize: 22 }}>{percent}%</Text>
                                <Text
                                    type="secondary"
                                    style={{ textTransform: 'uppercase', fontSize: 9, letterSpacing: '0.1em' }}
                                >
                                    completed
                                </Text>
                            </Space>
                        );
                    }}
                />
                <div className="regression-testing-progress-bars">
                    <Space direction="vertical">
                        {statuses.map((status, key) => (
                            <Space key={`status-${key}`}>
                                <Text style={{ minWidth: 30, textAlign: 'right', display: 'inline-block' }}>
                                    {status.count}
                                </Text>
                                <Progress
                                    className="bordered"
                                    percent={status.fraction * 100}
                                    strokeColor={`#${status.color}`}
                                    format={() => <Text type="secondary">{status.displayableName}</Text>}
                                    style={{ width: 200 }}
                                />
                            </Space>
                        ))}
                    </Space>
                </div>
            </Space>
        </div>
    );
};

export default RegressionTestingCharts;
